import posthog from "posthog-js";
import { API_BASE_URL } from "../api/config";

/** Public project API key (client-side). Safe to ship in the frontend bundle. */
const POSTHOG_KEY = "phc_trzjPifdFUevQd5cSkEwdBwCEpAgB8HKQtaEAUdCMwUn";
const POSTHOG_HOST = "https://us.i.posthog.com";

/**
 * Hosts that receive X-POSTHOG-DISTINCT-ID, X-POSTHOG-SESSION-ID, and
 * X-POSTHOG-WINDOW-ID so backend traces can link to this session.
 * Hostnames only — no protocol, port, or path.
 */
const POSTHOG_TRACING_HOSTS = ["api.akinda.io", "test-api.akinda.io"] as const;

function tracingHostnames(): string[] {
  const hosts = new Set<string>(POSTHOG_TRACING_HOSTS);
  try {
    hosts.add(new URL(API_BASE_URL).hostname);
  } catch {
    // Keep the known API hosts when the resolved base URL is not absolute.
  }
  return [...hosts];
}

let initStarted = false;

function isBrowser(): boolean {
  return typeof window !== "undefined";
}

/**
 * Initialize PostHog once per app lifecycle (client-only).
 */
export function initPostHog(): void {
  if (!isBrowser() || initStarted) return;

  initStarted = true;

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    defaults: "2026-05-30",
    person_profiles: "identified_only",
    capture_pageview: true,
    capture_pageleave: true,
    capture_exceptions: {
      capture_unhandled_errors: true,
      capture_unhandled_rejections: true,
      capture_console_errors: false,
    },
    tracing_headers: tracingHostnames(),
  });
}

export function isPostHogReady(): boolean {
  return isBrowser() && initStarted;
}

export function identifyPostHogUser(
  userId: string,
  properties?: Record<string, unknown>,
): void {
  if (!isPostHogReady()) return;
  posthog.identify(userId, properties);
}

export function resetPostHogUser(): void {
  if (!isPostHogReady()) return;
  posthog.reset();
}

export function capturePostHogEvent(
  eventName: string,
  properties?: Record<string, unknown>,
): void {
  if (!isPostHogReady()) return;
  posthog.capture(eventName, properties);
}

export { posthog };
export default posthog;
